import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useMutableRef } from '@carnica/utils/hooks';
var getNewValueArr = function getNewValueArr(item, value, getItemKey) {
  return value.some(function (val) {
    return getItemKey(val) === getItemKey(item);
  }) ? value.filter(function (val) {
    return getItemKey(val) !== getItemKey(item);
  }) : [].concat(_toConsumableArray(value), [item]);
};
export var useChipsGroup = function useChipsGroup(params) {
  var itemsProp = params.items,
    valueProp = params.value,
    getItemDisabled = params.getItemDisabled,
    getItemKey = params.getItemKey,
    layout = params.layout,
    _params$reorderItems = params.reorderItems,
    reorderItems = _params$reorderItems === void 0 ? true : _params$reorderItems,
    multiple = params.multiple,
    getItemOnClick = params.getItemOnClick,
    onChange = params.onChange;
  var onItemClickRef = useMutableRef(params.onItemClick);
  var getItemOnClickRef = useMutableRef(getItemOnClick);
  var onChangeRef = useMutableRef(onChange);
  var _useState = useState(itemsProp || []),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var value = useMemo(function () {
    return valueProp && (Array.isArray(valueProp) ? valueProp : [valueProp]) || [];
  }, [valueProp]);
  var onItemClick = useCallback(function (item) {
    return function (e) {
      var _onChangeRef$current, _onItemClickRef$curre, _getItemOnClickRef$cu, _getItemOnClickRef$cu2;
      if (getItemDisabled !== null && getItemDisabled !== void 0 && getItemDisabled(item)) {
        return;
      }
      (_onChangeRef$current = onChangeRef.current) === null || _onChangeRef$current === void 0 ? void 0 : _onChangeRef$current.call(onChangeRef, multiple ? getNewValueArr(item, value, getItemKey) : item, e);
      (_onItemClickRef$curre = onItemClickRef.current) === null || _onItemClickRef$curre === void 0 ? void 0 : _onItemClickRef$curre.call(onItemClickRef, item, e);
      (_getItemOnClickRef$cu = getItemOnClickRef.current) === null || _getItemOnClickRef$cu === void 0 ? void 0 : (_getItemOnClickRef$cu2 = _getItemOnClickRef$cu.call(getItemOnClickRef, item)) === null || _getItemOnClickRef$cu2 === void 0 ? void 0 : _getItemOnClickRef$cu2(e);
    };
  }, [value]);
  useEffect(function () {
    if (layout === 'collapse' && reorderItems) {
      var filteredItems = (itemsProp || []).filter(function (el) {
        return !value.find(function (item) {
          return getItemKey(el) === getItemKey(item);
        });
      });
      setItems([].concat(_toConsumableArray(value), _toConsumableArray(filteredItems)));
    } else {
      setItems(itemsProp || []);
    }
  }, [itemsProp, layout, value, reorderItems]);
  return useMemo(function () {
    return {
      value: value,
      items: items,
      onItemClick: onItemClick
    };
  }, [value, items, onItemClick]);
};